import { Capacitor } from '@capacitor/core';

export const isMobilePlatform = () => {
    const platform = Capacitor.getPlatform();
    return platform === 'android' || platform === 'ios';
};